import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _AbKeyMap;
/*
 *                     NOTICE
 *            COPYRIGHT 2022 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbIterable, AbIterableIterator } from "abweb/collection/AbIterable";
import { TypeUtils } from "abweb/utils/TypeUtils";
/**
 * Wrapper class around the native javascript Map which allows for keying based off of a keyFunction, provides
 * additional helper methods, and has a typesafe get method (returns a unique symbol when key is not found).
 */
export class AbKeyMap {
  constructor(iterable, _keyFunction, mergeFunction) {
    _defineProperty(this, "_map", new Map());
    _defineProperty(this, "clear", () => {
      this._map.clear();
    });
    _defineProperty(this, "delete", key => {
      return this._map.delete(TypeUtils.itemToKey(key, this.keyFunction));
    });
    _defineProperty(this, "forEach", callbackfn => {
      this._map.forEach(value => callbackfn(value.value, value.key, this));
    });
    _defineProperty(this, "get", key => {
      return this._map.get(TypeUtils.itemToKey(key, this.keyFunction))?.value ?? AbKeyMap.NOT_FOUND;
    });
    _defineProperty(this, "has", key => {
      return this._map.has(TypeUtils.itemToKey(key, this.keyFunction));
    });
    _defineProperty(this, "set", (key, value) => {
      this._map.set(TypeUtils.itemToKey(key, this.keyFunction), {
        key: key,
        value: value
      });
      return this;
    });
    _defineProperty(this, Symbol.iterator, () => {
      return this.entries();
    });
    _defineProperty(this, "entries", () => {
      return AbIterableIterator.from(this._map.values()).map(v => [v.key, v.value]);
    });
    _defineProperty(this, "keys", () => {
      return AbIterableIterator.from(this._map.values()).map(v => v.key);
    });
    _defineProperty(this, "values", () => {
      return AbIterableIterator.from(this._map.values()).map(v => v.value);
    });
    _defineProperty(this, "map", (mapFunction, keyFunction) => {
      return AbKeyMap.from(AbIterable.from(this.entries()).map(mapFunction), keyFunction);
    });
    _defineProperty(this, "filter", filterFunction => {
      return AbKeyMap.from(AbIterable.from(this.entries()).filter(filterFunction), this.keyFunction);
    });
    _defineProperty(this, Symbol.toStringTag, "AbKeyMap");
    this.keyFunction = _keyFunction;
    AbIterable.from(iterable ?? []).forEach(([key, newValue]) => {
      const existingValue = this.get(key);
      if (existingValue !== AbKeyMap.NOT_FOUND && mergeFunction) {
        const merged = mergeFunction(existingValue, newValue);
        this.set(key, merged);
      } else {
        this.set(key, newValue);
      }
    });
  }
  get size() {
    return this._map.size;
  }
}
_AbKeyMap = AbKeyMap;
_defineProperty(AbKeyMap, "from", (iterable, keyFunction, mergeFunction) => new _AbKeyMap(iterable, keyFunction, mergeFunction));
_defineProperty(AbKeyMap, "NOT_FOUND", Symbol("AbKeyMap Not Found"));
_defineProperty(AbKeyMap, "isNotFound", item => {
  return item === _AbKeyMap.NOT_FOUND;
});
//# sourceMappingURL=AbKeyMap.js.map
